import * as React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import { RootState } from '../store/rootReducer'
import { Location } from '../lib/interfaces/Location.interface'

import * as appSelectors from '../store/app/selectors'
import ChangeableBadge from './ChangeableBadge.component'

const find = require('lodash/find')

export interface LocationImageProps {
  style?: object
  className?: string
  locationCode: string
  locations: Location[]
  enableChange?: boolean
  children?: React.ReactNode
  changePermissions?: string[]
  onChange?: (location: Location) => void
}

class LocationImage extends React.PureComponent<LocationImageProps> {
  render() {
    const { style, onChange, className, locations, enableChange, locationCode, changePermissions } = this.props

    return (
      <div
        className={classnames('locationimage', className)}
        style={{ backgroundImage: `url(/assets/locations/${locationCode}.jpg)`, ...style }}
      >
        <ChangeableBadge
          options={locations}
          onChange={onChange}
          badgeText={locationCode}
          className="badge-white"
          enableChange={enableChange}
          changePermissions={changePermissions}
          getOptionLabel={location => location.code}
          value={find(locations, { code: locationCode })}
          getOptionValue={location => location.id.toString()}
        />
        {this.props.children}
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  locations: appSelectors.getLocations(state)
})

export default connect(mapStateToProps)(LocationImage)



// WEBPACK FOOTER //
// ./src/common/LocationImage.component.tsx